import { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { flattenedRoutes } from '../../routes';

export default () => {
  const history = useHistory();
  const params = useParams();
  const { loggedInRoutes, loggedOutRoutes } = flattenedRoutes;

  const pathTo = useCallback((id) => (
    loggedInRoutes.find(({ id: routeId }) => routeId === id)
    || loggedOutRoutes.find(({ id: routeId }) => routeId === id)
  ).path, [loggedInRoutes, loggedOutRoutes]);

  const urlTo = useCallback((id, paramValues = {}) => pathTo(id).replace(
    /:([^/]+)/g,
    (paramExpr) => {
      const paramName = paramExpr.replace(':', '').replace(/\(.+/, '');
      return paramValues[paramName] || params[paramName];
    }
  ), [pathTo, params]);

  const goTo = useCallback((id, paramValues) => history.push(
    urlTo(id, paramValues)
  ), [urlTo, history]);

  return {
    goTo,
    pathTo,
    urlTo,
    goBack: history.goBack,
    loggedInRoutes,
    loggedOutRoutes,
  };
};
